angular.module('zc.projects')

.directive 'campaignSegmentPanels', ($q, CampaignStats, AccessStats, currencies) ->
  restrict: 'E'
  scope: {
    project: '='
    campaign: '='
    filters: '='
  }
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_segment_panels.html'

  link: (scope, element, attrs) ->
    scope.currency = currencies[scope.project.currency]

    updateData = ->
      from = _.max([scope.campaign.start_at, moment(scope.filters.start_at).toDate()])
      from = moment(from).startOf('day').toDate()
      to = _.min([scope.campaign.end_at, moment(scope.filters.end_at).toDate()])
      to = moment(to).add(1, 'days').startOf('day').toDate()
      $q.all [
        CampaignStats.aggregate
          dimension: 'daily'
          campaign_id: scope.campaign.id
          apikey: scope.campaign.apikey
          start_at: from.valueOf()
          end_at: to.valueOf()
      ,
        AccessStats.aggregateDefault
          apikey: scope.campaign.apikey
          dimension: 'daily'
        ,
          device: AccessStats.handleCampaignDevice(scope.campaign.campaign_device)
          campaign_segment_id: (scope.campaign.segment?.id or null)
          is_control: null
          start_at:
            $gte: from
            $lt: to
      ]
      .then ([campaign_stats, access_stats]) ->
        scope.campaign_stats = CampaignStats.groupById(campaign_stats)[scope.campaign.id]
        scope.access_stats = access_stats[0]
    scope.$watch 'filters', updateData, true



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/campaign_segment_panels.coffee